import { STEPS_INTL_1 } from 'cohorts/intl_1/constants/steps'
import { STEPS_INTL_1T } from 'cohorts/intl_1t/constants/steps'
import { STEPS_INTL_2 } from 'cohorts/intl_2/constants/steps'
import { STEPS_INTL_2LW } from 'cohorts/intl_2lw/constants/steps'
import { STEPS_INTL_D60 } from 'cohorts/intl_d60/constants/steps'
import { STEPS_INTL_D70 } from 'cohorts/intl_d70/constants/steps'
import { STEPS_INTL_HLWN70 } from 'cohorts/intl_hlwn70/constants/steps'
import { STEPS_INTL_MW } from 'cohorts/intl_mw/constants/steps'
import { STEPS_INTL_3 } from 'cohorts/intl_3/constants/steps'
import { Cohort } from 'root-constants'
import type { TStep } from 'src/types'

export const STEPS_MAP: Record<Cohort, TStep[]> = {
  [Cohort.INTL_1]: STEPS_INTL_1,
  [Cohort.INTL_1T]: STEPS_INTL_1T,
  [Cohort.INTL_2]: STEPS_INTL_2,
  [Cohort.INTL_2LW]: STEPS_INTL_2LW,
  [Cohort.INTL_D60]: STEPS_INTL_D60,
  [Cohort.INTL_D70]: STEPS_INTL_D70,
  [Cohort.INTL_HLWN70]: STEPS_INTL_HLWN70,
  [Cohort.INTL_MW]: STEPS_INTL_MW,
  [Cohort.INTL_3]: STEPS_INTL_3,
}
